<template>
  <div>
    <el-menu class="navbar" mode="horizontal">
      <ul class="profile">


        <li>
          <el-dropdown :hide-on-click="true" :trigger="'click'" @command="handleCommand">
            <i class="icon-profile"></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="editProfile">Edit Profile</el-dropdown-item>
              <el-dropdown-item command="logout"> Logout</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

        </li>
        <li>

          <el-dropdown :hide-on-click="true" :trigger="'click'" @command="handleCommand">
            <i class="icon-settings"></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="addWidget">Add widget</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

        </li>
        <li class="notification" @click="setNewNotificationNull">
          <el-dropdown :hide-on-click="true" :trigger="'click'" @command="handleCommand">
            <i class="icon-notification"></i>
            <el-dropdown-menu slot="dropdown">

              <el-dropdown-item v-for="(item,index) in Notifications.slice(0,5)" :key="index">
                <notificationItem :notification="item" :index="index"></notificationItem>
              </el-dropdown-item>
              <el-dropdown-item v-if="Notifications.length===0"> No Notifications available</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span v-if="this.$store.getters.unSeenNotification!==0" id="NotificationsCount">{{this.$store.getters.unSeenNotification}}</span>
        </li>
        <Hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></Hamburger>

      </ul>

      <div class="main-brand">
        <div class="main-brand-container">
          <div class="main-logo"> TisaIOT </div>


        </div>
      </div>


    </el-menu>

    <profile ref="profile"></profile>
    <el-dialog title="New Widget" :close-on-press-escape="false" :visible.sync="dialogVisibleNewWidget"
               v-if="dialogVisibleNewWidget">

      <el-form :model="formNewWidget" ref="formNewWidget">
        <el-form-item label="Widget title" :label-width="formLabelWidth">
          <el-input v-model="formNewWidget.title" auto-complete="off" v-validate="'required'"
                    placeholder="Widget Title"/>
        </el-form-item>
        <el-form-item label="Widget Type" :label-width="formLabelWidth">
          <el-select v-model="formNewWidget.widgetType" placeholder="Please select a type">
            <el-option label="Chart widget" value="chartWidget"/>
            <el-option label="List widget" value="listWidget"/>
            <el-option label="Map widget" value="mapWidget"/>
          </el-select>
        </el-form-item>
        <el-form-item label="Widget Size" :label-width="formLabelWidth">
          <el-select v-model="formNewWidget.span" placeholder="Please select a size">
            <el-option label="Large (left)" value="16"></el-option>
            <el-option label="Small (right)" value="8"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Widget Icon" :label-width="formLabelWidth">
          <el-select v-model="formNewWidget.icon" placeholder="Please select an icon">
            <el-option value="icon-mail"><i class='icon-mail'></i></el-option>

          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleNewWidget = false">Cancel</el-button>
        <el-button type="primary" @click="handleConfirm">Confirm</el-button>
      </span>
    </el-dialog>

  </div>

</template>

<script>
  import {mapGetters} from "vuex";
  import Breadcrumb from "@/components/Breadcrumb";
  import Hamburger from "@/components/Hamburger";
  import ErrorLog from "@/components/ErrorLog";
  import Screenfull from "@/components/Screenfull";
  import ElDropdown from "element-ui/packages/dropdown/src/dropdown"
  import notificationItem from "./notification/notificationItem"
  import ElDialog from "element-ui/packages/dialog/src/component";
  import AddDevice from "../../settings/Device/addDevice.vue";
  import Settings from "../../settings/Settings.vue";
  import profile from '../components/profile/Profile'
  import firebase from 'firebase'

  export default {
    components: {
      profile,
      Settings,
      ElDialog,
      Breadcrumb,
      ElDropdown,
      Hamburger,
      ErrorLog,
      Screenfull,
      notificationItem

    },
    data() {
      return {

        dialogVisibleNewWidget: false,
        formNewWidget: {
          title: "",
          icon: "",
          widgetType: "",
          span: ""
        },
        formLabelWidth: "120px",
        Notifications: this.$store.getters.notifications,

      }
    },
    created() {

    },
    computed: {
      ...mapGetters(["sidebar", 'currentUser'])
    },
    methods: {
      hideTrigerSeting() {
        console.log('receved signal to hide the triger seting')
        this.dialogTriggerSettingsVisible = false;
      },
      toggleSideBar() {
        this.$store.dispatch("toggleSideBar");
      },
      logout() {
        let store = this.$store
        firebase.auth().signOut().then(function () {
          location.reload(true);
          // Sign-out successful clear local storage in here.
          store.state.user.authenticated = false;
          localStorage.clear();
        }, function (error) {
          // An error happened.
        });
      },
      handleCommand(command) {

        switch (command) {
          case "SensorType": // temporary for testing component
            this.SensorTypeFormVisible = true;
            break;
          case "AddDevice": // temporary for testing component
            this.AddDeviceDialogVisible = true;
            break;
          case "setUpTrigger":
            this.dialogTriggerSettingsVisible = true;
            console.log('Call to setting up triggers');
            break;
          case "saveDashboard":
            console.log("Call to save dashboard");
            break;
          case "addWidget":
            console.log("Call to add widget");
            this.dialogVisibleNewWidget = true;
            break;
          case "editProfile":
            this.$refs.profile.show()
            break;
          case "logout":
            this.logout();
            break;
          default:
            break;
        }
      },
      handleConfirm() {
        let widget = {
          widgetType: this.formNewWidget.widgetType,
          span: parseInt(this.formNewWidget.span),
          title: this.formNewWidget.title,
          icon: this.formNewWidget.icon
        };
        this.$store.dispatch("add_widget", widget).then(success => {
          location.reload();
        });
      }, setNewNotificationNull() {
        this.$store.dispatch('seenAll')
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },


      handleClose(done) {
        console.log(done)
        this.$confirm('Are you sure to close this dialog?')
        this.$confirm('Are you sure you want to close this dialog?', '', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        })
          .then(_ => {
            done();
          })
          .catch(_ => {
          });
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import '../../../styles/variables.scss';

  //set the parent li position to relative so that the child would have a reference based on the child
  .notification {
    position: relative;
  }

  .tab-element {
    color: #000 !important;
  }

  #NotificationsCount {
    width: 20px;
    height: 20px;
    position: absolute;
    top: -8px;
    left: 20px;
    text-align: center;
    color: white;
    font-size: 15px;
    background-color: red;
    border-radius: 50%;
  }

  .el-dropdown-menu__item:hover {
    background-color: $darkTransparent;
  }

  .el-dropdown-menu__item {
    color: $white;
    padding: 10px;
  }

  .el-dropdown-menu {
    background-color: $menuBg;
    border: $dark;
    color: white;
    //width: 30%;
    padding: 0;
  }

  .popper__arrow {
    color: $dark;
    border-color: black;

  }

  .navbar {

    height: 63px;
    background-color: transparent;
    border-radius: 0px !important;
    border: none !important;
    .el-dropdown {
      font-size: inherit;
    }
    .profile {
      position: fixed;
      top: 0;
      left: 0;
      width: 260px;
      background-color: rgba(0, 0, 0, .4);
      height: 63px;
      font-size: 18px;
      padding-left: 0px;
      display: flex;
      justify-content: space-around;
      align-items: center;

      li {
        list-style: none;
        border-radius: 50%;
        font-size: 1.6em;
        height: 28px;
        width: 28px;
        color: white;
        .el-dropdown {
          i {
            color: white;
          }
        }

        &:first-child {
          margin-left: 16px;
        }
        &:last-child {
          margin-right: 16px;
        }
        &:hover {
          background-color: rgba(255, 255, 255, 0.2);
        }

      }
      &:focus {
        outline: none;
      }
    }
    .main-search {
      position: fixed;
      padding-left: 70px;
      left: 261px;
      top: 0;
      background-color: rgba(0, 0, 0, .25);
      line-height: 63px;

      input {
        border: none;
        background-color: transparent;
        width: 313px;
        font-weight: 300;
        font-size: 16px;
        height: 60px;
        color: $white;
        &:focus {
          color: #e5e5e5;
          &::-webkit-input-placeholder { /* Chrome/Opera/Safari */
            color: #8a8a8a;
          }
          &::-moz-placeholder { /* Firefox 19+ */
            color: #e5e5e5;
          }
          &:-ms-input-placeholder { /* IE 10+ */
            color: #e5e5e5;
          }
          &:-moz-placeholder { /* Firefox 18- */
            color: #e5e5e5;
          }
        }

        &::-webkit-input-placeholder { /* Chrome/Opera/Safari */
          color: $white;
        }
        &::-moz-placeholder { /* Firefox 19+ */
          color: $white;
        }
        &:-ms-input-placeholder { /* IE 10+ */
          color: $white;
        }
        &:-moz-placeholder { /* Firefox 18- */
          color: $white;
        }
      }
      label {
        height: 63px;
        color: #e5e5e5;
        position: absolute;
        left: 40px;
        top: 0;
        font-size: 22px;
        cursor: pointer;
      }
      button {
        position: absolute;
        right: 10px;
        background: 0 0;
        border: 0;
        font-size: 36px;
        color: rgba(255, 255, 255, .9);
        top: 50%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        display: inline-block;
      }
    }

    .main-brand {
      position: fixed;
      width: calc(100% - 260px - 2px);
      right: 0;
      background-color: rgba(0, 0, 0, .4);
      height: 63px;
      line-height: 63px;

      .main-brand-container {
        position: absolute;
        right: 50px;
        .main-logo {
          display: inline-block;
          vertical-align: top;
          margin-right: 7px;
          font-size: 1.4em;
          font-weight: 200;
        }

      }
    }

    .hamburger-container {
      line-height: 74px;
      height: 63px;
      float: left;
      padding: 0 10px;
    }
    .breadcrumb-container {
      float: left;
    }
    .errLog-container {
      display: inline-block;
      vertical-align: top;
    }
    .right-menu {
      float: right;
      height: 100%;
      &:focus {
        outline: none;
      }
      .right-menu-item {
        display: inline-block;
        margin: 0 8px;
      }
      .screenfull {
        height: 20px;
      }
      .international {
        vertical-align: top;
      }

      .avatar-container {
        height: 50px;
        margin-right: 30px;
        .avatar-wrapper {
          cursor: pointer;
          margin-top: 5px;
          position: relative;
          .user-avatar {
            width: 40px;
            height: 40px;
            border-radius: 10px;
          }
          .el-icon-caret-bottom {
            position: absolute;
            right: -20px;
            top: 25px;
            font-size: 12px;
          }
        }
      }

    }
  }

</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue